module.exports = __webpack_public_path__ + "static/media/Pullman Avenue, Half Moon Bay, CA13.08014370.jpg";